import { Component, OnInit } from '@angular/core';
import {AccessService } from '../service/access.service'
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { ModErrorComponent } from '../modals/mod-error/mod-error.component';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-access-approvers-list',
  templateUrl: './access-approvers-list.component.html',
  styleUrls: ['./access-approvers-list.component.css']
})
export class AccessApproversListComponent implements OnInit {
  //variable bussiness
  bUnits: any;
  approvers: any;
  pageSize = 10;
  pageNumber = 1;
  SeeItems: any[] = [];
  totalPage: any [] = [];
  SeeAllSite: any[] = [];
  SeeAllPick: any[]=[];
  totalItems: number;
  pageSizeOptions: any
  statusOptions: any;

  selectZone: any = [];
  site: any = [];
  selectBusiness: any = [];
  siteCC: any;
  zoneCC: any;
  oneSapZone: string;
  oneSapSite: string;
  submited= false;

  //-----------Filters
  requestF: string;
  typeF: string;
  statusF: string;
  requestDateF: string;
  //---------URL MAKE
  order: string;
  baseReq: string;
  //-----------------Asc&Desc state-------
  requestDesc = false;
  typeDesc = false;
  statusDesc = false;
  requestDateDesc = false;
  //---------------datepicker
  formSelectBu: UntypedFormGroup;
  maxDate: Date;
  dateSelectStart: Date;
  dateSelectEnd: Date;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private dataApi: AccessService,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog
  ) { }

  getApproversBU(buCode){
    if(this.formSelectBu.valid){
        this.spinner.show("loading");
        this.dataApi.getAllApproversByBu(buCode, this.oneSapSite, this.oneSapZone).subscribe((data: any) => {
          this.spinner.hide("loading");
          this.approvers = data;
          this.submited = true;
        },(err) => {
          this.spinner.hide("loading");
          if(err.error.error !== 'Invalid token.') {
            this.dialog.open(ModErrorComponent, {
              width: 'auto',
              panelClass: 'myapp-no-padding-dialog',
            });
          }
        });
    }
  }
  getBussinnesPeople() {
    this.spinner.show("loading");
    this.dataApi.getEmployeeAccess().subscribe((data: any) => {
      this.spinner.hide("loading");
      this.site = data.sites;
      this.selectBusiness = data.businessUnits;
    },(err) => {
       this.spinner.hide("loading");
       if(err.error.error !== 'Invalid token.') {
        this.dialog.open(ModErrorComponent, {
          width: 'auto',
          panelClass: 'myapp-no-padding-dialog',
        });
       }
     });
  }

  ngOnInit() {
    this.formSelectBu = this.formBuilder.group({
      bussinesUnitCode: ['', Validators.required],
      zoneId: ['', Validators.required],
      siteId: ['', Validators.required]
    });
    this.getBussinnesPeople();
  }


  changeSelectSite(siteId) {
    for (const siteOP of this.site) {
      if (siteOP.id === Number(siteId)) {
        this.selectZone = siteOP.zones;
        this.siteCC = siteOP.codeCC;
        this.oneSapSite = siteOP.code1Sap;
      }
      this.formSelectBu.controls['zoneId'].setValue('');
      this.cleanSubzoneBU();
    }
  }
  changeSelectZone(zoneId) {
    for (const zoneOP of this.selectZone) {
      if (zoneOP.id === Number(zoneId)) {
        this.oneSapZone = zoneOP.code1Sap;
      }
      this.cleanSubzoneBU();
    }
  }
  cleanSubzoneBU() {
    this.approvers = [];
    this.formSelectBu.controls['bussinesUnitCode'].setValue('');

  }


  clearFilter(){
  }
  getallCardFilter(){
  }
  orderby(a,b){
  }
  handlePage(e: PageEvent) {
    this.pageSize = e.pageSize;
    this.pageNumber = e.pageIndex + 1;
    this.getallcardapprover();
  }

  getallcardapprover() {

  }
}
